/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { Platform, TouchableOpacity, View } from "react-native";

import { Text, styles } from "UpduoLibrary";
import { skaleLinkBlue, skaleWebTextLightGray } from "config/UpduoColors";

export default function BackExploreBar({ onBack, previousTitle }) {
  const [backHover, setBackHover] = useState(false);

  const color = backHover ? skaleLinkBlue : skaleWebTextLightGray;
  return (
    <View style={styles.subNavigationBar}>
      <TouchableOpacity
        {...Platform.select({
          web: {
            onMouseEnter: () => {
              setBackHover(true);
            },
            onMouseLeave: () => {
              setBackHover(false);
            },
          },
        })}
        style={{
          height: 24,
          flexDirection: "row",
          alignItems: "center",
          borderColor: color,
        }}
        onPress={onBack}
      >
        <Text style={{ fontSize: 14, color }}>
          {`« Back to ${previousTitle}`}
        </Text>
      </TouchableOpacity>
    </View>
  );
}
